<script lang="ts" setup>
interface Mail {
  subject?: string
  body?: string
}

withDefaults(defineProps<Mail>(), {
  subject: '',
  body: ''
})
</script>

<template>
  <slot name="prefix" />
  <a
    v-bind="$attrs"
    :href="`mailto:support@plentify.io${(subject || body) && `?subject=${subject}&body=${body}`}`"
  >
    <slot>support@plentify.io</slot>
  </a>
</template>

<style lang="scss" scoped>
a {
  font-size: inherit;
}
</style>
